module.exports = __webpack_public_path__ + "static/media/promo-anetwork.b4703582.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/promo-anetwork.jpg
// module id = 310
// module chunks = 0